import moment from 'moment';
import {Component, Input, Output, EventEmitter} from '@angular/core';
import { ApiService } from '../../../../api/api.service';
import {AssistanceTicket} from '../../../../models/assistanceticket';
import { LoaderService } from '../../../../api/loader.service';

@Component({
    selector: 'app-service-config',
    templateUrl: './service-config.component.html',
    styleUrls: ['./service-config.component.css'],
    standalone: false
})
export class ServiceConfigComponent  {
 

  editticket: AssistanceTicket;
  configType: number;
  programtime: any;
  comment: string;
  program_type: any = null;
  assistance_programming_types: any = [];
  
  @Input() Ticket: EventEmitter<AssistanceTicket>;
  @Output() setService = new EventEmitter<AssistanceTicket>();
  @Output() cancelEvent = new EventEmitter();
  constructor(public api: ApiService,private LoaderService: LoaderService) {
    
  }

  initialize() {

    // Get programming types
    this.LoaderService.display(true)
    this.api.assistance_programming_types
      .get()
      .promise()
      .then(resp => {
        
        this.assistance_programming_types = resp;
        this.LoaderService.display(false)
      }, e => {
        
      
      })

    if (this.Ticket) {
      this.Ticket.subscribe(data => {
        this.editticket = Object.assign({}, data.ticket);
        this.editticket.datetime = new Date();
        this.editticket.program_type = null;
        this.configType = null;
        this.comment = '';
        this.program_type = null;
      });
    }
  }



  onSelectType(type_num) {
    this.configType = type_num;
    if (this.configType === 1) {
      this.programtime = new Date().getHours() + ':' + new Date().getMinutes();
    }
  }

  onSelectday(date) {
    if (date === null) {
      // this.fieldsRequired['programdate'] = true;
    } else {
      const set_date = date + ' ' + this.programtime;
      // this.editticket.datetime = new Date(set_date);
      this.editticket.datetime = moment(set_date).toDate();
      // this.fieldsRequired['programdate'] = false;
    }
  }

  onSelectTime() {
    const set_date = this.editticket.datetime.toDateString() + ' ' + this.programtime;
    // this.editticket.datetime = new Date(set_date);
    this.editticket.datetime = moment(set_date).toDate();
  }

  onCancel() {
    this.cancelEvent.emit();
  }

  onSubmit() {
    if (this.configType === 1) {
      this.editticket.ticket_type = 11;
    } else if (this.configType === 2) {
      this.editticket.ticket_type = 12;
     }else if(this.configType === 3){
       this.editticket.ticket_type = 15;
     }
    this.editticket.comment = this.comment;
    this.setService.emit(this.editticket);
  }

  onSelectProgramType(event) {
    let value = event.target.value;
    this.program_type = +value || null;
    this.editticket.program_type = +value || null;
  }

}
